import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const ComscoreTracker = () => {
  const location = useLocation();
  const lastPageRef = useRef("");

  useEffect(() => {
    const currentPage =
      location.pathname + location.search;

    // 🔐 Prevent duplicate hits for same URL
    if (lastPageRef.current === currentPage) return;

    lastPageRef.current = currentPage;

    // Legacy queue (safe)
    window._comscore = window._comscore || [];
    window._comscore.push({
      c1: "2",
      c2: "38736750",
      page: currentPage,
    });

    // Force SPA beacon
    if (window.COMSCORE && window.COMSCORE.beacon) {
      window.COMSCORE.beacon({
        c1: "2",
        c2: "38736750",
        page: currentPage,
      });
    }
  }, [location.pathname, location.search]);

  return null;
};

export default ComscoreTracker;
